"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TODO = exports.typeSafeIndex = exports.parseJSON = exports.assertNonNullish = exports.dangerousUncheckedTypeCast = exports.exhaustiveTypeException = exports.exhaustiveTypeCheck = exports.isInArray = void 0;
const isInArray = (value, array) => array.includes(value);
exports.isInArray = isInArray;
const exhaustiveTypeCheck = (_) => void _;
exports.exhaustiveTypeCheck = exhaustiveTypeCheck;
const exhaustiveTypeException = (type) => new Error(`Assertion failed: "unreachable" code reached with unknown type: ${typeof type === 'object' ? JSON.stringify(type) : String(type)}`);
exports.exhaustiveTypeException = exhaustiveTypeException;
/**
 * Please use this instead of using the 'as' keyword directly, so it's easier
 * to screen for these ticking time bombs in the code from time to time. Or
 * better yet, just implement validation for your types straight away.
 *
 * If you would think twice before using this, then by pure logic you should
 * likewise also think twice - no, make it at least thrice - before making the
 * decision to opt into undefined behaviour by letting the compile-time TS type
 * diverge from the runtime JS value.
 *
 * This is your last chance to turn back.
 *
 * You have been warned.
 *
 * @example
 * ```ts
 * const someData = await AsyncStorage.getItem(SOME_KEY);
 * const parsedData = JSON.parse(someData);
 * const data = dangerousUncheckedTypeCast<SomeDataType>(parsedData);
 * ```
 */
const dangerousUncheckedTypeCast = (value) => value;
exports.dangerousUncheckedTypeCast = dangerousUncheckedTypeCast;
/**
 * Wrapper for TypeScript's non-nullish assertion operator (`!`). Use this
 * instead of the operator directly so it's easier to spot. And, again, only
 * use this if you 100% know what you're doing. If you're not sure, then don't!
 */
const assertNonNullish = (value) => value;
exports.assertNonNullish = assertNonNullish;
/**
 * Safer alternative to `JSON.parse`. Returns `unknown` instead of `any`.
 *
 * @see JSON.parse
 */
exports.parseJSON = JSON.parse;
/**
 * Same as `array[index]`, but adds `undefined` to the return type. Maybe some
 * fine day we will enable `noUncheckedIndexedAccess` in all our projects. 🤞
 */
const typeSafeIndex = (array, index) => array[index];
exports.typeSafeIndex = typeSafeIndex;
const TODO = (message) => {
    throw new Error(message !== null && message !== void 0 ? message : 'Not implemented');
};
exports.TODO = TODO;
